import angular from 'angular'
import { react2angular } from 'react2angular'
import MerchantBalanceSummary from './MerchantBalanceSummary.react'
import '../../../main/factory/settlement'
import '../../../core/main/factory/feature'

angular.module('merchant.application.module.settlement.merchantBalanceSummary', [
    "merchant.application.main"
  ])
  .controller('merchant.application.module.settlement.merchantBalanceSummary.controller',
    ['$rootScope', '$scope', '$controller'],
    function ($rootScope, $scope, $controller) {
      $controller('merchant.application.module.controller', { $scope: $scope })
    })
  .component('merchantBalanceSummary',
    react2angular(MerchantBalanceSummary,
      ['showSettlementModal', 'showTaxInvoiceModal', 'pausedStatus', 'configuration', 'currentReserves', 'merchantId', 'rollingReserves'],
      ['$scope']))
